import { useEffect, useRef, useState } from "react";
import { db } from "../firebase";
import { deleteOnCondition, getData, getDocDataOnCondition, handleFireBaseUpload } from "../Firebase/firestore";

function UpdateFabric() {

    const categories = [
        {
            id: "Suits",
            label: "Suits",
            icon: "SUI",
            cloths: ["Coat", "Vest", "Shirt", "Pant"],
        },
        {
            id: "formal",
            label: "Formal",
            icon: "FOR",
            cloths: ["Shirt", "Pant"],
        },
        {
            id: "kurta",
            label: "Kurta Set",
            icon: "KUR",
            cloths: ["Kurta", "Pajama", "Sadri", "Coat"],
        },
        {
            id: "blazer",
            label: "Blazer",
            icon: "BLZ",
            cloths: ["Coat"],
        },
    ]

    const [state, setState] = useState({ cloth: "Coat", type: "Suits" })
    const [stockFilter, setStockFilter] = useState("all")

    const currentCategory = categories.find((c) => c.id === state.type) || categories[0]
    const [Data, setData] = useState()

    const [preview, setPreview] = useState()
    const [IMG, setIMG] = useState()

    const [Sload, setSLoad] = useState({ "s": false, "k": 0 })

    const [modal, setModal] = useState({ "s": false, "id": -1, "t": 1 })
    const [currPreview, setCurrPreview] = useState()

    const price = useRef()
    const [search, setSearch] = useState()

    const [delmodal, setDelModal] = useState({ s: false, "id": "" })

    const [loadR, setLoadR] = useState({ "s": false, "k": 0 })

    // Recommended buttons editing
    const MAX_RECOM_BUTTONS = 5
    const BUTTON_MATERIAL_FILTERS = ["all", "metal", "plastic", "wood", "fabric", "ring"]
    const [Buttons, setButtons] = useState([])
    const [editBtnModal, setEditBtnModal] = useState(null)
    const [editRecomButtons, setEditRecomButtons] = useState([])
    const [editDefaultBtnId, setEditDefaultBtnId] = useState(null)
    const [editRecomSearch, setEditRecomSearch] = useState("")
    const [editRecomMaterialFilter, setEditRecomMaterialFilter] = useState("all")
    const [savingButtons, setSavingButtons] = useState(false)


    const getTypeData = async (type) => {
        if (!Data || (Data && !Data[state.cloth]) || (Data && Data[state.cloth] && !Data[state.cloth][state.type])) {
            const collection = db.collection("Fabric").doc(state.type)
            var data = await getData(collection.collection(type))
            var fin = { ...Data }

            if (fin[state.cloth]) {
                fin[state.cloth][state.type] = data
            } else {
                fin[state.cloth] = { [state.type]: data }
            }

            setData(fin)

            data.sort((a, b) => a.fabric.localeCompare(b.fabric));

            fin[state.cloth][state.type] = data
            setData(fin)
        }
    }

    const getPreviewImages = async (id, coll = "style") => {
        try {
            const collection = db.collection("Fabric").doc(state.type).collection(`${state.cloth}_style`).doc(id).collection(coll)
            const STYLES = await getData(collection)
            return STYLES
        } catch (e) {
            console.log("From preview", e)
        }
    }

    const updateFabricDB = async (id, obj, typ = 0) => {
        try {
            const collection = db.collection("Fabric").doc(state.type).collection(`${state.cloth}`)
            var data = await getDocDataOnCondition(collection, "id", id)
            const DOC = data[0]["id"]
            data = data[0]["data"]
            var url = null
            if ("single" in obj) {
                data["single"][0] = obj["single"]
                delete obj["single"]
            }
            data = { ...data, ...obj }

            await collection.doc(DOC).set(data)
            return url
        } catch (e) {
            console.log("error from DB", e)
        }
    }

    const addFabric = async (id, type = "style") => {
        try {
            const collection = db.collection("Fabric").doc(state.type).collection(`${state.cloth}_style`).doc(id).collection(type)

            var ref = ""
            if (type === "style") { ref = `Fabrics/${state.type}/${state.cloth}/Styles` }
            else { ref = `${state.type}/${state.cloth}` }

            var name = IMG.name.split(".")[0]

            const url = await handleFireBaseUpload(name + "-" + (new Date().getTime()).toString(), IMG, ref)

            if ((name === "1B-N-FL" || name === "F-DP" || name === "BASE" || name === "DB")) {
                var j = 0
                var temp = [...Data]
                for (var i = 0; i < Data.length; i++) {
                    if (temp[i]["id"] === id) {
                        j = i;
                        break
                    }
                }
                if (type === "style") {
                    temp[j]["single"][0] = url
                    await updateFabricDB(id, { "single": url })
                } else {
                    await updateFabricDB(id, { "src": url })
                    temp["src"] = url
                }
                setData(temp)
            }

            await collection.doc(name).set({ "src": url });

            var arr = [...(currPreview || [])]
            arr.push({ "doc": name, "src": url })
            setCurrPreview(arr)
            return url
        } catch (e) {
            console.log(e)
        }
    }

    const removeStock = async (id, stock, key) => {
        try {
            const collection = db.collection("Fabric").doc(state.type).collection(state.cloth)
            const D = (await getDocDataOnCondition(collection, "id", id))[0]

            await collection.doc(D["id"]).set({
                ...D["data"],
                ...{ "stock": stock }
            })

            var fin = { ...Data }
            fin[state.cloth][state.type][key]["stock"] = stock
            setData(fin)
        } catch (e) {
            console.log(e)
        }
    }

    const deleteFabricTypes = async (t = 0) => {
        try {
            const id = delmodal.id
            const k = delmodal.key

            const fabric = Data[state.cloth][state.type][k]
            const fabID = fabric.fabricID

            setLoadR({ s: true, k: k })
            const doc_c = db.collection('Fabric').doc(state.type)

            let temp = [...Data[state.cloth][state.type]]
            temp.splice(k, 1)

            if (t === 1) {
                const types = ['Coat', 'Vest', 'Pant']
                for (let i = 0; i < types.length; i++) {
                    const collection = doc_c.collection(types[i])
                    const ID = await deleteOnCondition(collection, "fabricID", fabID)
                    await doc_c.collection(`${types[i]}_style`).doc(ID).delete()
                }
            } else {
                const collection = doc_c.collection(state.cloth)
                const ID = await deleteOnCondition(collection, "id", id)
                await doc_c.collection(`${state.cloth}_style`).doc(ID).delete()
            }

            setLoadR({ s: false, k: k })

            var fin = { ...Data }
            fin[state.cloth][state.type] = temp
            setData(fin)
            setDelModal({ s: false })
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        try {
            getTypeData(state.cloth).then(() => { })
        } catch (e) {
            console.log("from upadting fabrics", e)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])

    useEffect(() => {
        const fetchButtons = async () => {
            const data = await getData(db.collection('Buttons'))
            setButtons(data || [])
        }
        fetchButtons()
    }, [])

    const openEditBtnModal = (value) => {
        const savedIds = Array.isArray(value.recommended_buttons) ? value.recommended_buttons : []
        const preSelected = savedIds.map((id) => Buttons.find((b) => b.id === id)).filter(Boolean)
        setEditRecomButtons(preSelected)
        setEditDefaultBtnId(value.default_recommended_button || (preSelected[0]?.id || null))
        setEditRecomSearch("")
        setEditRecomMaterialFilter("all")
        setEditBtnModal(value)
    }

    const saveRecomButtons = async () => {
        if (!editBtnModal) return
        try {
            setSavingButtons(true)
            const ids = editRecomButtons.map((b) => b.id)
            const payload = {
                recommended_buttons: ids,
                ...(ids.length && editDefaultBtnId ? { default_recommended_button: editDefaultBtnId } : { default_recommended_button: null }),
            }
            await updateFabricDB(editBtnModal.id, payload)
            // update local data
            var fin = { ...Data }
            const arr = fin[state.cloth][state.type]
            const idx = arr.findIndex((x) => x.id === editBtnModal.id)
            if (idx !== -1) {
                arr[idx] = { ...arr[idx], ...payload }
                setData(fin)
            }
            setEditBtnModal(null)
        } catch (e) {
            console.log("save recom buttons", e)
            alert("Failed to save. Please try again.")
        } finally {
            setSavingButtons(false)
        }
    }

    const filterResults = () => {
        if (Data && Data[state.cloth] && Data[state.cloth][state.type] && search) {
            const terms = search.toLowerCase().split(" ")
            var final = { ...Data }

            for (let i = 0; i < Data[state.cloth][state.type].length; i++) {
                const element = Data[state.cloth][state.type][i]
                terms.forEach((ts) => {
                    if (JSON.stringify(element).toLowerCase().includes(ts)) {
                        final[state.cloth][state.type][i]["filter"] = true
                    } else {
                        final[state.cloth][state.type][i]["filter"] = false
                    }
                })
            }
            setData(final)
        }
    }

    const outfitItems = (state && Data && Data[state.cloth] && Data[state.cloth][state.type]) || [];
    const visibleOutfits = outfitItems.filter((value) => {
        const oos = Object.hasOwn(value, "stock") && !value.stock;
        if (stockFilter === "instock" && oos) return false;
        if (stockFilter === "oos" && !oos) return false;
        if (!search) return true;
        if (Object.hasOwn(value, "filter")) return value.filter;
        return true;
    });

    return (
        <div className="UpdateFabric edit-outfit-page">
            <div className="edit-fabric-filterbar edit-outfit-filterbar edit-outfit-filterbar-v2">
                <div className="edit-outfit-filter-row edit-outfit-filter-row-top">
                    <div className="edit-outfit-category-tabs">
                        {categories.map((cat) => (
                            <button
                                key={cat.id}
                                type="button"
                                className={`edit-outfit-cat-tab ${state.type === cat.id ? "active" : ""}`}
                                onClick={() => {
                                    const firstCloth = cat.cloths[0];
                                    setState({ type: cat.id, cloth: firstCloth });
                                    setSearch("");
                                }}
                            >
                                <span className="edit-outfit-cat-tab-icon">{cat.icon}</span>
                                <span className="edit-outfit-cat-tab-label">{cat.label}</span>
                            </button>
                        ))}
                    </div>

                    <div className="edit-outfit-filter-divider" />

                    <div className="edit-outfit-cloth-chips">
                        {currentCategory.cloths.map((cl) => (
                            <button
                                key={cl}
                                type="button"
                                className={`edit-outfit-chip ${state.cloth === cl ? "active" : ""}`}
                                onClick={() => {
                                    setState({ ...state, cloth: cl });
                                    setSearch("");
                                }}
                            >
                                {cl}
                            </button>
                        ))}
                    </div>

                    <div className="edit-outfit-filter-right">
                        <div className="edit-outfit-stock-toggle">
                            {[
                                { id: "all", label: "All" },
                                { id: "instock", label: "In Stock" },
                                { id: "oos", label: "Out" },
                            ].map((s) => (
                                <button
                                    key={s.id}
                                    type="button"
                                    className={`edit-outfit-stock-opt ${stockFilter === s.id ? "active" : ""}`}
                                    onClick={() => setStockFilter(s.id)}
                                >
                                    {s.label}
                                </button>
                            ))}
                        </div>
                        <div className="edit-outfit-count-badge">
                            <strong>{visibleOutfits.length}</strong>
                            <span>Outfits</span>
                        </div>
                    </div>
                </div>

                <div className="edit-outfit-filter-row">
                    <div className="edit-outfit-search-box edit-outfit-search-box-v2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <input
                            className="search_fabric_clothes"
                            placeholder="Search outfits (brand, fabric, name)"
                            value={search || ""}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") filterResults(); }}
                        />
                        <button type="button" className="edit-outfit-search-apply" onClick={() => filterResults()}>
                            Search
                        </button>
                    </div>
                </div>
            </div>

            <div className={`edit-outfit-list ${state.cloth === "Sadri" ? "edit-outfit-list-sadri" : ""}`}>
                {!Data || !Data[state.cloth] || !Data[state.cloth][state.type] ? (
                    <div className="edit-outfit-empty">
                        <div className="edit-outfit-spinner" />
                        <p>Loading outfits…</p>
                    </div>
                ) : visibleOutfits.length === 0 ? (
                    <div className="edit-outfit-empty">
                        <p>No outfits found for <strong>{state.cloth}</strong> in <strong>{currentCategory.label}</strong>.</p>
                    </div>
                ) : (
                    outfitItems.map((value, key) => {
                        if (search && Object.hasOwn(value, "filter") && !value.filter) return null;
                        const outOfStock = Object.hasOwn(value, "stock") && !value.stock;
                        if (stockFilter === "instock" && outOfStock) return null;
                        if (stockFilter === "oos" && !outOfStock) return null;
                        return (
                            <div
                                key={value.id || key}
                                className={`edit-outfit-card ${outOfStock ? "edit-outfit-card-oos" : ""}`}
                            >
                                {outOfStock && (
                                    <div className="edit-outfit-oos-badge">
                                        <span className="edit-outfit-oos-dot" />
                                        Out of Stock
                                    </div>
                                )}

                                {loadR && loadR.s && loadR.k === key && (
                                    <div className="edit-outfit-card-loading">
                                        <div className="edit-outfit-spinner" />
                                    </div>
                                )}

                                <div className={`edit-outfit-images ${state.cloth === "Sadri" ? "edit-outfit-images-single" : ""}`}>
                                    <div className="edit-outfit-image-box">
                                        <div className="edit-outfit-image-thumb">
                                            <img src={value["src"]} alt={value.fabric || "Display"} />
                                        </div>
                                        <button
                                            type="button"
                                            className="edit-outfit-image-action"
                                            onClick={async () => {
                                                setModal({ s: true, id: value.id, t: 1 });
                                                const D = await getPreviewImages(value.id, "display");
                                                setCurrPreview(D);
                                            }}
                                        >
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                                            Display Images
                                        </button>
                                    </div>
                                    {state.cloth !== "Sadri" && (
                                        <div className="edit-outfit-image-box">
                                            <div className="edit-outfit-image-thumb">
                                                <img src={value["single"] && value["single"][0]} alt={value.fabric || "Style"} />
                                            </div>
                                            <button
                                                type="button"
                                                className="edit-outfit-image-action"
                                                onClick={async () => {
                                                    setModal({ s: true, id: value.id, t: 2 });
                                                    const D = await getPreviewImages(value.id);
                                                    setCurrPreview(D);
                                                }}
                                            >
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.912 5.887L20 10l-5 3.633L16.425 20 12 16.5 7.575 20 9 13.633 4 10l6.088-1.113L12 3z"></path></svg>
                                                Style Images
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="edit-outfit-details">
                                    <div className="edit-outfit-row">
                                        <span className="edit-outfit-row-label">Brand</span>
                                        <strong className="edit-outfit-row-value">{value.brand || "-"}</strong>
                                    </div>
                                    <div className="edit-outfit-row">
                                        <span className="edit-outfit-row-label">Fabric</span>
                                        <strong className="edit-outfit-row-value">{value.fabric || "-"}</strong>
                                    </div>

                                    <div className="edit-outfit-inline-edit">
                                        <div className="edit-outfit-inline-edit-head">
                                            <span className="edit-outfit-inline-edit-label">Price</span>
                                            <span className="edit-outfit-current-value">₹{value.price || 0}</span>
                                        </div>
                                        <input
                                            className="edit-outfit-inline-input"
                                            placeholder="Enter new price"
                                            id={`PRICE_${key}`}
                                        />
                                    </div>

                                    <div className="edit-outfit-inline-edit">
                                        <div className="edit-outfit-inline-edit-head">
                                            <span className="edit-outfit-inline-edit-label">Discount</span>
                                            <span className="edit-outfit-current-value">{value.discount ? value.discount : 0}%</span>
                                        </div>
                                        <input
                                            className="edit-outfit-inline-input"
                                            placeholder="Enter new discount"
                                            id={`Discount_${key}`}
                                        />
                                    </div>

                                    <div className="edit-outfit-recom-row">
                                        <div className="edit-outfit-recom-row-head">
                                            <span className="edit-outfit-inline-edit-label">Recommended Buttons</span>
                                            <span className="edit-outfit-current-value">
                                                {Array.isArray(value.recommended_buttons) && value.recommended_buttons.length > 0
                                                    ? `${value.recommended_buttons.length} selected`
                                                    : "None"}
                                            </span>
                                        </div>
                                        {Array.isArray(value.recommended_buttons) && value.recommended_buttons.length > 0 && (
                                            <div className="edit-outfit-recom-thumbs">
                                                {value.recommended_buttons.slice(0, 5).map((bid) => {
                                                    const btn = Buttons.find((b) => b.id === bid)
                                                    return btn ? (
                                                        <img
                                                            key={bid}
                                                            src={btn.src}
                                                            alt={btn.name || "Button"}
                                                            className="edit-outfit-recom-thumb"
                                                            title={btn.name || bid}
                                                        />
                                                    ) : null
                                                })}
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className="edit-outfit-btn edit-outfit-btn-update edit-outfit-recom-edit-btn"
                                            onClick={() => openEditBtnModal(value)}
                                        >
                                            Edit Buttons
                                        </button>
                                    </div>
                                </div>

                                <div className="edit-outfit-actions">
                                    <button
                                        type="button"
                                        className="edit-outfit-btn edit-outfit-btn-update"
                                        onClick={async () => {
                                            const p = document.getElementById(`PRICE_${key}`).value;
                                            const d = document.getElementById(`Discount_${key}`).value;
                                            if (d || p) {
                                                setLoadR({ s: true, k: key });
                                                var temp = { ...Data };
                                                var index = 0;
                                                for (var i = 0; i < temp[state.cloth][state.type].length; i++) {
                                                    if (temp[state.cloth][state.type][i]["id"] === value.id) {
                                                        index = i;
                                                        break;
                                                    }
                                                }
                                                if (p) {
                                                    await updateFabricDB(value.id, { price: p });
                                                    temp[state.cloth][state.type][index]["price"] = p;
                                                }
                                                if (d) {
                                                    await updateFabricDB(value.id, { discount: d });
                                                    temp[state.cloth][state.type][index]["discount"] = d;
                                                }
                                                setData(temp);
                                                setLoadR({ s: false, k: key });
                                            }
                                        }}
                                    >
                                        Update
                                    </button>
                                    <button
                                        type="button"
                                        className={`edit-outfit-btn ${outOfStock ? "edit-outfit-btn-stock-add" : "edit-outfit-btn-stock-remove"}`}
                                        onClick={async () => {
                                            setLoadR({ s: true, k: key });
                                            const sto = Object.hasOwn(value, "stock") ? !value["stock"] : 0;
                                            await removeStock(value.id, sto, key);
                                            setLoadR({ s: false, k: key });
                                        }}
                                    >
                                        {outOfStock ? "Add Stock" : "Remove Stock"}
                                    </button>
                                    <button
                                        type="button"
                                        className="edit-outfit-btn edit-outfit-btn-delete"
                                        onClick={() => setDelModal({ s: true, id: value.id, key: key })}
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <polyline points="3 6 5 6 21 6"></polyline>
                                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                            <path d="M10 11v6M14 11v6"></path>
                                            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                                        </svg>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            {editBtnModal && (
                <div className="recom-modal-backdrop" onClick={() => !savingButtons && setEditBtnModal(null)}>
                    <div className="recom-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Edit Recommended Buttons</h3>
                                <p>
                                    Outfit: <b>{editBtnModal.fabric || editBtnModal.id}</b> · {state.cloth} · Select up to {MAX_RECOM_BUTTONS}.
                                </p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={() => setEditBtnModal(null)} aria-label="Close">×</button>
                        </div>

                        <div className="recom-modal-filterbar">
                            <div className="recom-modal-chips">
                                {BUTTON_MATERIAL_FILTERS.map((mat) => (
                                    <button
                                        key={mat}
                                        type="button"
                                        className={`recom-modal-chip ${editRecomMaterialFilter === mat ? "active" : ""}`}
                                        onClick={() => setEditRecomMaterialFilter(mat)}
                                    >
                                        {mat}
                                    </button>
                                ))}
                            </div>
                            <div className="recom-modal-search">
                                <input
                                    type="text"
                                    placeholder="Search button by name"
                                    value={editRecomSearch}
                                    onChange={(ev) => setEditRecomSearch(ev.target.value)}
                                />
                            </div>
                        </div>

                        <div className="recom-modal-body">
                            {(() => {
                                const filtered = Buttons.filter((b) => {
                                    if ((b.targetType || "").toLowerCase() !== (state.cloth || "").toLowerCase()) return false
                                    if (editRecomMaterialFilter !== "all" && (b.material || "").toLowerCase() !== editRecomMaterialFilter) return false
                                    if (editRecomSearch && !JSON.stringify(b).toLowerCase().includes(editRecomSearch.toLowerCase())) return false
                                    return true
                                })
                                if (filtered.length === 0) {
                                    return <div className="recom-modal-empty">No buttons found for <b>{state.cloth}</b>{editRecomMaterialFilter !== "all" ? ` · ${editRecomMaterialFilter}` : ""}{editRecomSearch ? ` matching "${editRecomSearch}"` : ""}.</div>
                                }
                                return (
                                    <div className="recom-modal-grid">
                                        {filtered.map((btn) => {
                                            const isSelected = !!editRecomButtons.find((b) => b.id === btn.id)
                                            const rank = editRecomButtons.findIndex((b) => b.id === btn.id)
                                            return (
                                                <div
                                                    key={btn.id}
                                                    className={`recom-button-card ${isSelected ? "selected" : ""}`}
                                                    onClick={() => {
                                                        if (isSelected) {
                                                            const next = editRecomButtons.filter((b) => b.id !== btn.id)
                                                            setEditRecomButtons(next)
                                                            if (editDefaultBtnId === btn.id) setEditDefaultBtnId(next[0]?.id || null)
                                                        } else {
                                                            if (editRecomButtons.length >= MAX_RECOM_BUTTONS) {
                                                                alert(`Max ${MAX_RECOM_BUTTONS} buttons allowed. Deselect one first.`)
                                                                return
                                                            }
                                                            const next = [...editRecomButtons, btn]
                                                            setEditRecomButtons(next)
                                                            if (!editDefaultBtnId) setEditDefaultBtnId(btn.id)
                                                        }
                                                    }}
                                                >
                                                    <div className="recom-button-card-image-wrap">
                                                        <img src={btn.src} alt={btn.name || "Button"} className="recom-button-card-image" />
                                                        {isSelected && <span className="recom-button-card-check" aria-hidden>#{rank + 1}</span>}
                                                    </div>
                                                    <div className="recom-button-card-details">
                                                        <div className="recom-button-card-name" title={btn.name || "-"}>{btn.name || "Untitled"}</div>
                                                        <div className="recom-button-card-specs">
                                                            <div className="recom-button-spec-row">
                                                                <span className="recom-button-spec-label">Material</span>
                                                                <span className="recom-button-spec-value">{btn.material || "-"}</span>
                                                            </div>
                                                            <div className="recom-button-spec-row">
                                                                <span className="recom-button-spec-label">Target</span>
                                                                <span className="recom-button-spec-value">{btn.targetType || "-"}</span>
                                                            </div>
                                                            {btn.color && (
                                                                <div className="recom-button-spec-row">
                                                                    <span className="recom-button-spec-label">Color</span>
                                                                    <span className="recom-button-spec-value recom-button-spec-color">
                                                                        <span className="recom-button-color-dot" style={{ background: btn.color }}></span>
                                                                        <span className="recom-button-color-hex">{btn.color}</span>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {isSelected && (
                                                        <div className="recom-button-card-actions">
                                                            {editDefaultBtnId === btn.id ? (
                                                                <span className="recom-default-pill">Default for outfit</span>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="recom-use-default-btn"
                                                                    onClick={(ev) => { ev.stopPropagation(); setEditDefaultBtnId(btn.id) }}
                                                                >
                                                                    Use as default
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })()}
                        </div>

                        <div className="recom-modal-footer">
                            <span className="recom-modal-summary">
                                {editRecomButtons.length} / {MAX_RECOM_BUTTONS} selected · default: {editDefaultBtnId ? (editRecomButtons.find((b) => b.id === editDefaultBtnId)?.name || "—") : "—"}
                            </span>
                            <div className="recom-modal-actions">
                                <button
                                    type="button"
                                    className="fabric-submit-btn recom-modal-clear"
                                    onClick={() => { setEditRecomButtons([]); setEditDefaultBtnId(null) }}
                                    disabled={editRecomButtons.length === 0}
                                >
                                    Clear
                                </button>
                                <button
                                    type="button"
                                    className="fabric-submit-btn recom-modal-done"
                                    onClick={saveRecomButtons}
                                    disabled={savingButtons}
                                >
                                    {savingButtons ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {delmodal.s && (                <div className="edit-outfit-modal-backdrop" onClick={() => setDelModal({ s: false })}>
                    <div className="edit-outfit-modal edit-outfit-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="edit-outfit-modal-header">
                            <h3>Delete {state.cloth}</h3>
                            <button type="button" className="edit-outfit-modal-close" onClick={() => setDelModal({ s: false })} aria-label="Close">×</button>
                        </div>
                        <div className="edit-outfit-modal-body">
                            <p>
                                You are about to delete a <strong>{state.cloth}</strong> from <strong>{state.type}</strong>.
                            </p>
                            {state.type === "Suits" && (
                                <div className="edit-outfit-delete-info">
                                    <div>
                                        <span className="edit-outfit-delete-info-tag">Delete ALL</span>
                                        Removes pieces of the same fabric &amp; brand from all Coats, Shirts, Pants &amp; Vests.
                                    </div>
                                    <div>
                                        <span className="edit-outfit-delete-info-tag edit-outfit-delete-info-tag-alt">Only this</span>
                                        Removes only this {state.cloth}.
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="edit-outfit-modal-actions">
                            <button type="button" className="edit-outfit-btn-cancel" onClick={() => setDelModal({ s: false })}>
                                Cancel
                            </button>
                            {state.type === "Suits" && (
                                <button type="button" className="edit-outfit-btn-delete-all" onClick={async () => await deleteFabricTypes(1)}>
                                    Delete ALL
                                </button>
                            )}
                            <button type="button" className="edit-outfit-btn-confirm-delete" onClick={async () => await deleteFabricTypes()}>
                                {state.type === "Suits" ? "Delete Only This" : "Confirm Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {modal.s && (
                <div
                    className="edit-outfit-modal-backdrop"
                    onClick={() => { setModal({ s: false }); setCurrPreview(null); setPreview(null); setSLoad({ s: false, k: 0 }); }}
                >
                    <div className="edit-outfit-modal edit-outfit-preview-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="edit-outfit-modal-header">
                            <h3>{modal.t === 1 ? "Display Images" : "Style Images"}</h3>
                            <button
                                type="button"
                                className="edit-outfit-modal-close"
                                onClick={() => { setModal({ s: false }); setCurrPreview(null); setPreview(null); setSLoad({ s: false, k: 0 }); }}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>

                        <div className="edit-outfit-modal-body edit-outfit-preview-body">
                            <div className="edit-outfit-preview-grid">
                                <div className="edit-outfit-preview-card edit-outfit-preview-add">
                                    <div className="edit-outfit-preview-thumb">
                                        {preview && preview.id === -1 ? (
                                            <img src={preview["src"]} alt="New" />
                                        ) : (
                                            <div className="edit-outfit-preview-placeholder">
                                                <span>+</span>
                                                <em>Select a file</em>
                                            </div>
                                        )}
                                        {Sload && Sload.s && Sload.k === -1 && (
                                            <div className="edit-outfit-preview-loading">
                                                <div className="edit-outfit-spinner" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="edit-outfit-preview-info">
                                        <strong>Add New Image</strong>
                                        <span className="edit-outfit-preview-name">
                                            {preview && preview.id === -1 ? preview.name : "No file selected"}
                                        </span>
                                        <label className="edit-outfit-preview-file">
                                            <input
                                                id="previewUpload"
                                                type="file"
                                                onChange={(e) => {
                                                    const File = e.target.files[0];
                                                    if (!File) return;
                                                    const newName = File.name;
                                                    setIMG(File);
                                                    const objectUrl = URL.createObjectURL(File);
                                                    setPreview({ src: objectUrl, name: newName, id: -1 });
                                                }}
                                            />
                                            <span>Choose File</span>
                                        </label>
                                        <button
                                            type="button"
                                            className="edit-outfit-preview-add-btn"
                                            disabled={!(preview && preview.id === -1)}
                                            onClick={async () => {
                                                setSLoad({ s: true, k: -1 });
                                                if (modal.t && modal.t === 1) {
                                                    await addFabric(modal.id, "display");
                                                } else {
                                                    await addFabric(modal.id);
                                                }
                                                setSLoad({ s: false, k: -1 });
                                                setPreview(null);
                                            }}
                                        >
                                            Add Image
                                        </button>
                                    </div>
                                </div>

                                {currPreview && currPreview.map((val, k) => (
                                    <div key={val.doc || k} className="edit-outfit-preview-card">
                                        <div className="edit-outfit-preview-thumb">
                                            <img src={preview && preview.id === k ? preview["src"] : val["src"]} alt={val.doc} />
                                        </div>
                                        <div className="edit-outfit-preview-info">
                                            <strong>{val.doc}</strong>
                                            <span className="edit-outfit-preview-name">Existing image</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UpdateFabric;
